import { observable, action } from 'mobx';
import ApiCaller from '../utils/api-caller';

class hotelTvChannelStore {
    @observable menu = null;
    @observable items = [];

    @action getData() {
        const languageCode = window.localStorage.getItem('lang') || 'en';
        return ApiCaller.CmsTasks.getTv(languageCode).then(resp => {
            if (resp) {
                this.menu = resp.menu;
                this.items = resp.items;
            }
        });
    }
}

export default new hotelTvChannelStore()